<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Sales & Orders
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Management</a>
          <ul>
            <li @click="activeMenuLink = '/sales/customer-orders'"><router-link to="/sales/customer-orders"  :class="{'is-active':activeMenuLink === '/sales/customer-orders'}">Customer Orders</router-link></li>
            
          </ul>
        </li>

         <li>
          <a class="">Designs</a>
          <ul>
            <li @click="activeMenuLink = '/sales/upload-design'"><router-link to="/sales/upload-design"  :class="{'is-active':activeMenuLink === '/sales/upload-design'}">Upload Design</router-link></li>
            
          </ul>
        </li>
        
        
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
export default {
  name: 'SideBarSales',
  components: {
  },
  data() {
    return { activeMenuLink: null }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  }
}

</script>



